(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pbp-edit-carousels"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pbp-flyer-carousel')) {
    customElements.define('pbp-flyer-carousel', class extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.track = this.querySelector('.pbp-flyers__track');
        this.slides = [...this.querySelectorAll('[data-slide]')];
        this.dots = [...this.querySelectorAll('[data-dot]')];
        this.play = this.querySelector('[data-play]');
        this.status = this.querySelector('[data-status]');
        this.index = 0;
        if (this.slides.length < 2 || !this.play) return;
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.paused = this.dataset.autoplay !== 'true' || this.motion.matches || this.hasAttribute('data-editor');
        this.inView = false;
        this.hovered = false;
        this.focused = false;
        this.querySelector('.pbp-flyers__controls').hidden = false;
        this.querySelector('[data-prev]').addEventListener('click', () => this.go(this.index - 1, true), options);
        this.querySelector('[data-next]').addEventListener('click', () => this.go(this.index + 1, true), options);
        this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.go(index, true), options));
        this.play.addEventListener('click', () => {
          this.paused = !this.paused;
          this.update();
          this.schedule();
        }, options);
        this.track.addEventListener('pointerdown', () => this.stopForUser(), options);
        this.track.addEventListener('touchstart', () => this.stopForUser(), { ...options, passive: true });
        this.track.addEventListener('wheel', (event) => {
          if (Math.abs(event.deltaX) > Math.abs(event.deltaY)) this.stopForUser();
        }, { ...options, passive: true });
        this.track.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          const next = event.key === 'Home' ? 0 : event.key === 'End' ? this.slides.length - 1 : this.index + (event.key === 'ArrowRight' ? 1 : -1);
          this.go(next, true);
        }, options);
        this.track.addEventListener('scroll', () => {
          clearTimeout(this.scrollTimer);
          this.scrollTimer = setTimeout(() => {
            const width = this.track.clientWidth;
            if (width) this.index = Math.max(0, Math.min(this.slides.length - 1, Math.round(this.track.scrollLeft / width)));
            this.update();
          }, 90);
        }, { ...options, passive: true });
        this.addEventListener('mouseenter', () => { this.hovered = true; this.schedule(); }, options);
        this.addEventListener('mouseleave', () => { this.hovered = false; this.schedule(); }, options);
        this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, options);
        this.addEventListener('focusout', (event) => {
          if (!this.contains(event.relatedTarget)) { this.focused = false; this.schedule(); }
        }, options);
        document.addEventListener('visibilitychange', () => this.schedule(), options);
        this.motion.addEventListener('change', () => { if (this.motion.matches) this.stopForUser(); }, options);
        this.addEventListener('shopify:block:select', (event) => {
          const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
          if (index >= 0) this.go(index, true);
        }, options);
        this.observer = new IntersectionObserver(entries => {
          this.inView = entries[0].isIntersecting;
          this.schedule();
        }, { threshold: 0.15 });
        this.observer.observe(this);
        this.resize = new ResizeObserver(() => {
          this.track.scrollTo({ left: this.index * this.track.clientWidth, behavior: 'instant' });
        });
        this.resize.observe(this.track);
        this.update();
      }
      stopForUser() {
        this.paused = true;
        clearTimeout(this.timer);
        this.update();
      }
      go(index, manual = false) {
        if (manual) this.stopForUser();
        this.index = (index + this.slides.length) % this.slides.length;
        this.track.scrollTo({ left: this.index * this.track.clientWidth, behavior: this.motion.matches ? 'instant' : 'smooth' });
        this.update();
      }
      update() {
        this.dots.forEach((dot, index) => {
          if (index === this.index) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
        this.slides.forEach((slide, index) => slide.setAttribute('aria-hidden', String(index !== this.index)));
        this.play.setAttribute('aria-label', this.paused ? this.dataset.playLabel : this.dataset.pauseLabel);
        this.play.querySelector('[data-play-icon]').textContent = this.paused ? '\u25b6' : '\u275a\u275a';
        this.status.setAttribute('aria-live', this.paused ? 'polite' : 'off');
        this.status.textContent = this.slides[this.index].getAttribute('aria-label') || '';
      }
      schedule() {
        clearTimeout(this.timer);
        if (this.paused || this.hovered || this.focused || !this.inView || document.hidden) return;
        this.timer = setTimeout(() => { this.go(this.index + 1); this.schedule(); }, 5000);
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.abort = null;
        this.observer?.disconnect();
        this.resize?.disconnect();
        clearTimeout(this.timer);
        clearTimeout(this.scrollTimer);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
